var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { BREAKPOINT } from "../../theme/constants";
export var Items = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: 0;\n"], ["\n  padding-left: 0;\n"])));
export var Item = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n"])));
export var TickCircleIconWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: 0.8rem;\n"], ["\n  margin-right: 0.8rem;\n"])));
export var ListWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  h2 {\n    margin-top: 1.2rem;\n    text-align: center;\n  }\n\n  @media ", " {\n    h2 {\n      text-align: left;\n      margin-top: 0;\n    }\n  }\n"], ["\n  h2 {\n    margin-top: 1.2rem;\n    text-align: center;\n  }\n\n  @media ", " {\n    h2 {\n      text-align: left;\n      margin-top: 0;\n    }\n  }\n"])), BREAKPOINT.lg);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;